import { render, staticRenderFns } from "./productCommentForm.vue?vue&type=template&id=129bfa3c"
import script from "./productCommentForm.vue?vue&type=script&lang=js"
export * from "./productCommentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports